import { ElementRef, Injectable } from '@angular/core';

import { InfoBoxClassName } from './utils/constants';

@Injectable()
export class InfoBoxService {
  private items: ElementRef[] = [];

  registerForcedInfoBox(elRef: ElementRef): void {
    this.items.push(elRef);
  }

  unregisterForcedInfoBox(elRef: ElementRef): void {
    this.items = this.items.filter(item => item !== elRef);
  }

  toggleForcedInfoBoxes(): void {
    this.items.forEach(item => {
      item.nativeElement.classList.toggle(InfoBoxClassName.OPACITY);
    });
  }
}
